import { render, staticRenderFns } from "./app-tag.vue?vue&type=template&id=370a65f3&scoped=true"
import script from "./app-tag.vue?vue&type=script&lang=js"
export * from "./app-tag.vue?vue&type=script&lang=js"
import style0 from "./app-tag.vue?vue&type=style&index=0&id=370a65f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370a65f3",
  null
  
)

export default component.exports